module.exports = __webpack_public_path__ + "assets/img/events-point-02.deb2e9a0.png";